import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
import "./Dashboard.less"
import ReactJson from "react-json-view"
import { withRouter } from "../../lib/withRouter"
import Header2 from "../Header2"
import { getQuickSightUrl, getViewPatientData } from "../../lib"
import moment from "moment"

export class TrafficCop extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

    }

    render() {
        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />
                </div>

                <div className="patient-search-results">
                    <iframe src="https://p.datadoghq.com/sb/embed/24b251b1-ea6a-11f0-bbd1-12a789a5ca13-f271f175f5e0026f0fdbb2fdb56180fe" title="Dashboard Name" width={"100%"} height="800"></iframe>
                </div>
            </div>
        )
    }

}

export default connect(state => state)(withRouter(TrafficCop));